import React, { useContext } from 'react';
import { type FeatureFlags } from './types';
export type { FeatureFlags };

const FeatureFlagsContext = React.createContext<FeatureFlags>({
	fireFeatureExposed: () => {},
});

export const useFeatureFlags = () => useContext<FeatureFlags>(FeatureFlagsContext);
export const FeatureFlagsProvider = FeatureFlagsContext.Provider;
